import StlModal from 'features/StlModal/StlModal';
import FontAwesomeIcon from 'features/common/FontAwesomeIcon';
import { StlButton } from 'features/common/StlButton/StlButton';

import { ReactComponent as AddElements } from '../common/icons/add_elements.svg';
import { useODUIMode } from './hooks/useODUIMode';

const MODAL_DESCR = `Run an analysis for origin destination.
See traffic impact, OD Matrix, and most traveled routes instantly.`;
const MODAL_TITLE = `Create New Analysis To Get Started`;

export default function ODCreateModal() {
  const { setCreateMode } = useODUIMode();

  return (
    <StlModal
      title={MODAL_TITLE}
      descr={MODAL_DESCR}
      upper={<AddElements width={209} height={140} />}
      lower={
        <div>
          <StlButton
            width={176}
            handleClick={setCreateMode}
            isActive
            bold
            icon={<FontAwesomeIcon name="plus" sx={{ color: 'inherit' }} />}
            value="Create New Analysis"
          />
        </div>
      }
    />
  );
}
